import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

import config from '../../config';
import logo from '../../assets/img/content/logo-new.webp';
import { LogoPattern } from '../../components/LogoPattern';

import style from './style.module.css';

const NotFound = () => (
  <div className={style.host}>
    <Helmet
      defaultTitle=""
      htmlAttributes={{ lang: 'en' }}
      meta={[
        { charset: 'utf-8' },
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
        { name: 'description', content: '' },
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0',
        },
        { name: 'msapplication-tap-highlight', content: 'no' },
        { name: 'mobile-web-app-capable', content: 'yes' },
        { name: 'application-name', content: config.appName },
        { name: 'apple-mobile-web-app-capable', content: 'yes' },
        { name: 'apple-mobile-web-app-status-bar-style', content: 'black' },
        { name: 'apple-mobile-web-app-title', content: config.appName },
        {
          name: 'msapplication-TileImage',
          content: '/assets/img/general/touch/ms-touch-icon-144x144-precomposed.png',
        },
        { name: 'msapplication-TileColor', content: config.color },
        { name: 'theme-color', content: config.color },
      ]}
      title="Not Found"
      titleTemplate="%s"
    />
    <LogoPattern />
    <div className={style.card}>
      <div className={style.brand}>
        <img alt="Harvey & Company" className={style.logo} src={logo} />
      </div>
      <div className={style.body}>
        <div className={style.code}>404</div>
        <h1 className={style.title}>Page not found</h1>
        <p className={style.text}>The page you are looking for does not exist or has been moved.</p>
        <Link className="btn btn-primary btn-block" to="/">
          Go to Home page
        </Link>
      </div>
    </div>
  </div>
);

export default NotFound;
